export const StaffValidation = (data) => {
  return new Promise((resolve) => {
    const errors = {};

    // Required field validations
    if (!data.name || data.name.trim() === "") {
      errors.name = "Full name is required";
    }

    if (!data.email || data.email.trim() === "") {
      errors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
      errors.email = "Please enter a valid email address";
    }

    if (!data.contact || data.contact.trim() === "") {
      errors.contact = "Contact number is required";
    } else if (!/^\d{10}$/.test(data.contact.replace(/\D/g, ''))) {
      errors.contact = "Please enter a valid 10-digit contact number";
    }

    if (!data.designation || data.designation.trim() === "") {
      errors.designation = "Designation is required";
    }

    // Optional field validations (only validate if provided)
    if (data.dob && data.dob.trim() !== "") {
      const dobDate = new Date(data.dob);
      const today = new Date();
      if (dobDate >= today) {
        errors.dob = "Date of birth must be in the past";
      }
    }

    if (data.doj && data.doj.trim() !== "") {
      const dojDate = new Date(data.doj);
      const today = new Date();
      if (dojDate > today) {
        errors.doj = "Date of joining cannot be in the future";
      }
    }

    if (data.salary && data.salary.trim() !== "") {
      const salaryNum = parseFloat(data.salary);
      if (isNaN(salaryNum) || salaryNum < 0) {
        errors.salary = "Please enter a valid salary amount";
      }
    }

    if (data.workHourPerDay && data.workHourPerDay.trim() !== "") {
      const hoursNum = parseInt(data.workHourPerDay);
      if (isNaN(hoursNum) || hoursNum < 1 || hoursNum > 24) {
        errors.workHourPerDay = "Working hours must be between 1 and 24";
      }
    }

    if (!data.img || data.img.trim() === "") {
      errors.img = "Profile image URL is required";
    } else {
      try {
        new URL(data.img);
      } catch {
        errors.img = "Please enter a valid image URL";
      }
    }

    // Address validation (optional but if provided, should not be too short)
    if (data.address && data.address.trim() !== "" && data.address.trim().length < 10) {
      errors.address = "Address should be at least 10 characters long";
    }

    resolve(errors);
  });
};